import { Component } from 'js-component-framework';
import PositionSticky from 'utils/PositionSticky';
import AriaPopup from 'js-component-framework/lib/plugins/AriaPopup';

export default class LongFormMenu extends Component {
  /**
   * Constructor. Binds function scope.
   * @param {object} config - config for this component.
   */
  constructor(config) {
    super(config);

    this.setupHeader = this.setupHeader.bind(this);
    this.stickHeader = this.stickHeader.bind(this);
    this.initMenuToggle = this.initMenuToggle.bind(this);
    this.initChildMenu = this.initChildMenu.bind(this);

    this.setupHeader();
    this.initMenuToggle();
    this.initChildMenu();
  }

  /**
   * Add class and page styles to accommodate fixed header.
   */
  setupHeader() {
    this.sticky = new PositionSticky(
      this.element,
      {
        stick: 'is-scrolling',
      }
    );

    // On load, do the thing.
    this.stickHeader();

    // Fixes load issues in some cases where function above doesn't fire. Legacy browsers.
    window.addEventListener(
      'load',
      this.stickHeader
    );

    // On resize (accommodate shrinking header).
    window.addEventListener(
      'resize',
      this.stickHeader
    );
  }

  /**
   * Add margin to article for sticky header.
   */
  stickHeader() {
    const { article, headerInnerWrap, menuToggleWrapperClosed } = this.children;

    const containerHeight = headerInnerWrap.offsetHeight;
    const menuHeight = menuToggleWrapperClosed.offsetHeight;
    const headerHeight = containerHeight + menuHeight;

    if (article) {
      article.classList.add('is-visible');
      article.style.marginTop = `${headerHeight}px`;
    }

    // Strip menu-open class from selector if on desktop.
    if (
      768 < (
        window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth
      )
    ) {
      const { menuToggleButton, menuToggleWrapper } = this.children;

      if (menuToggleWrapper) {
        menuToggleWrapper.classList.remove('menu-open');
      }

      if (menuToggleButton) {
        menuToggleButton.classList.remove('menu-open');
      }
    }

    const hasFeaturedImage = document.querySelector('.has-featured-image');

    if (hasFeaturedImage) {
      hasFeaturedImage.classList.add('is-visible');

      if (headerHeight && 0 < headerHeight) {
        hasFeaturedImage.style.paddingTop = `${headerHeight}px`;
      } else {
        hasFeaturedImage.style.paddingTop = 0;
      }
    }
  }

  /**
   * Initialize the menu button toggle
   */
  initMenuToggle() {
    const {
      menuToggleButton,
      menuToggleTarget,
      menuToggleWrapper,
    } = this.children;

    if (
      null === menuToggleButton ||
      null === menuToggleTarget ||
      null === menuToggleWrapper) {
      return;
    }

    this.menuToggle = new AriaPopup({
      controller: menuToggleButton,
      target: menuToggleTarget,
    });

    menuToggleButton.addEventListener('click', () => {
      if (! this.menuToggle.isExpanded) {
        menuToggleWrapper.classList.add('menu-open');
      } else {
        menuToggleWrapper.classList.remove('menu-open');
      }
    });
  }

  /**
   * Initialize menu child dropdown menus with cooresponding toggle.
   */
  initChildMenu() {
    const { childMenuItems } = this.children;

    if (null === childMenuItems) {
      return;
    }

    childMenuItems.forEach((item) => {
      const controller = item.querySelector('.grandchild-menu-toggle');
      const target = item.querySelector('.single-longform__grandchild-menu');

      if (null === controller || null === target) {
        return;
      }

      this.childMenuToggle = new AriaPopup({ controller, target });

      controller.addEventListener('click', () => {
        if (! this.childMenuToggle.isExpanded) {
          target.parentElement.classList.add('grandchild-menu-open');
        } else {
          target.parentElement.classList.remove('grandchild-menu-open');
        }
      });
    });
  }
}
